<template>
  <footer class="nc-footer">
    <slot />
  </footer>
</template>

<script>
export default {
  name: 'NcFooter',
};
</script>

<style scoped>
.nc-footer {
  position: sticky;
  bottom: 0;
  z-index: 100;
  background: var(--nc-bg);
  border-top: 1px solid var(--nc-border);
  padding-bottom: var(--nc-safe-area-bottom);
  flex-shrink: 0;
}
</style>

